import { hexToRgb, Theme } from '@mui/material'
import styled from '@mui/system/styled'

import { addOpacityToRGB } from './utils'

type ColorPalleteProps = {
  color: string
  actived?: boolean
  size?: number
}

const groupIconModifield = {
  actived: (theme: Theme) => ({
    outline: `3px solid ${theme.palette.primary.main}`,
    boxShadow: '0px 0px 6px #00E188'
  })
}

export const GroupIconWrapper = styled('div')<ColorPalleteProps>(
  ({ theme, color, actived, size = 45 }) => ({
    boxSizing: 'border-box',
    flexShrink: 0,
    width: size,
    height: size,
    background: addOpacityToRGB(hexToRgb(color), 0.6),
    borderRadius: 40,
    padding: Math.round(size / 9),

    outlineOffset: 2,
    ...(actived && groupIconModifield.actived(theme as Theme))
  })
)
